import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { Reveal } from "./Reveal";
import { STATS } from "../../lib/content";

const Counter = ({ value }) => {
  const m = value.match(/^([\d.]+)(.*)$/);
  const num = parseFloat(m[1]);
  const suffix = m[2];
  const decimals = (m[1].split(".")[1] || "").length;
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [d, setD] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const c = animate(0, num, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setD(v.toFixed(decimals)),
    });
    return () => c.stop();
  }, [inView, num, decimals]);

  return (
    <span ref={ref}>
      {d}
      <span className="text-[#3B5FE8]">{suffix}</span>
    </span>
  );
};

export const StatsBand = () => (
  <section className="noise-overlay bg-[#0A0C14] py-20 lg:py-28" data-testid="stats-band">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-12">The moment is now</p>
      </Reveal>
      <div className="grid grid-cols-2 gap-x-8 gap-y-14 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div data-testid={`stat-${i}`}>
              <p className="font-heading text-5xl font-medium tracking-tighter text-white sm:text-6xl lg:text-7xl">
                <Counter value={s.value} />
              </p>
              <p className="mt-3 max-w-[220px] text-sm text-slate-400">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
